module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ui":{"shared":{"go_to":{"company_profile":"To company profile","user":"Show Profile"}}}}}')
  delete Component.options._Ctor
}
